import { toast } from "react-toastify";
import Api from "../../../axios";
import { callLoader } from "../../../common/actions/app";

let ACTION_COMPANY_LIST = {
    type: 'COMPANY_LIST',
    payload: {
        rows: [],
        total: 0,
        pagination: [],
    },
};

let ACTION_COMPANY_VIEW = {
    type: 'COMPANY_VIEW',
    payload: {
        name: '',
        username: '',
    },
};

let ACTION_COMPANY_SELECT = {
    type: 'COMPANY_SELECT',
    payload: [],
};

let callCompanyListGet = (filter = {}, pg = 1) => (dispatch) => {
    dispatch(callLoader(true))
    Api.get('/companies?pg=' + pg).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        ACTION_COMPANY_LIST.payload.rows = data.rows
        ACTION_COMPANY_LIST.payload.total = data.total
        ACTION_COMPANY_LIST.payload.pagination = data.pagination
        dispatch(ACTION_COMPANY_LIST)
    })
}

let callCompanyViewGet = (id) => (dispatch) => {
    dispatch(callLoader(true))
    Api.get('/companies/' + id).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        ACTION_COMPANY_VIEW.payload.name = data.name
        dispatch(ACTION_COMPANY_VIEW)
    })
}

let callCompanyPost = (data, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.post('/companies', data).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        toast.success(data.msg)
        success()
    })
}

let callCompanyPut = (id, data, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.put('/companies/' + id, data).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        toast.success(data.msg)
        success()
    })
}

let callCompanyClearView = () => (dispatch) => {
    ACTION_COMPANY_VIEW.payload.name = ''
    dispatch(ACTION_COMPANY_VIEW)
}

let callCompanyDelete = (id, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.delete('/companies/' + id).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        toast.success(data.msg)
        success()
    })
}

let callCompanySelectGet = () => (dispatch) => {
    dispatch(callLoader(true))
    Api.get('/companies/select').then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        ACTION_COMPANY_SELECT.payload = data
        dispatch(ACTION_COMPANY_SELECT)
    })
}

export { callCompanyListGet, callCompanyViewGet, callCompanyPost, callCompanyPut, callCompanyDelete, callCompanyClearView, callCompanySelectGet, ACTION_COMPANY_LIST, ACTION_COMPANY_VIEW, ACTION_COMPANY_SELECT }